import React, { Component } from 'react';
import FormTable from '../../../Fields/FormTable.js';
import FormTableSelectFilter from '../../../Fields/FormTableSelectFilter.js';
import { getTranslation } from '../../../Utilities/GetTranslation.js'
import { getDateString, getJsonDate } from '../../../Utilities/JsonFunctions.js';

class ControlProjects extends Component {
    render() {
        var columns = [
            {
                Header: getTranslation("sns.general.extranet.ref"),
                accessor: "missionId",
                width: 100
            },
            {
                Header: getTranslation("sns.general.extranet.projecttitle"),
                accessor: "title",
                minWidth: 300,
                Filter: ({filter, onChange}) => {
                    return (<FormTableSelectFilter filter={filter} onChange={onChange} data={this.props.projects} accessor="title" />);
                },
                Cell: row => (
                    <a title={row.value} onClick={(e) => this.props.onNavigateToProject(row.row._original)}>{row.value}</a>
                ),
                filterMethod: (filter, row) => {
                    const id = filter.pivotId || filter.id;
                    if (row[id] !== null) {
                        if(row[id] === undefined)
                            return true;
                        
                        return  row[id].toString().toLowerCase() === filter.value.toString().toLowerCase();
                    }
                }
            },
            {
                Header: getTranslation("sns.general.extranet.status"),
                accessor: "isClosed",
                width: 100,
                Filter: ({filter, onChange}) => {
                    return (
                        <div className="select-wrapper">
                            <select
                                onChange={event => onChange(event.target.value)}
                                value={filter ? filter.value : ""}>
                                <option value=""></option>
                                <option value="false">{getTranslation("sns.webparts.applications.open")}</option>
                                <option value="true">{getTranslation("sns.webparts.applications.closed")}</option>
                            </select>
                        </div>
                    );
                },
                Cell: row => (
                    <div>
                        {
                            row.value === true ?
                                <span className="text-danger">{getTranslation("sns.webparts.applications.closed")}</span> :
                                <span className="text-success">{getTranslation("sns.webparts.applications.open")}</span>
                        }
                    </div>
                )
            },            
            {
                Header: getTranslation("sns.general.extranet.datstart"),
                accessor: "datStart",
                width: 125,
                filterable: false,
                Cell: row => {
                    return <span>{getDateString(getJsonDate(row.value))}</span>
                }
            },
            {
                Header: getTranslation("sns.general.extranet.candidates"),
                accessor: "nrCandidates",
                width: 125,
                filterable: false,
                show: this.props.onNavigateToCandidates != null,
                Cell: row => (
                    <a className="subcatlink" onClick={(e) => this.props.onNavigateToCandidates(row.row._original)}><span className="alignnumeric">{row.value}</span> <i className="fa fa-id-card-o" aria-hidden="true"></i></a>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.documents"),
                accessor: "nrDocuments",
                width: 125,
                filterable: false,
                Cell: row => (
                    <a className="subcatlink" onClick={(e) => this.props.onNavigateToDocuments(row.row._original)}><span className="alignnumeric">{row.value}</span> <i className="fa fa-paperclip" aria-hidden="true"></i></a>
                )
            },
            {
                Header: getTranslation("sns.general.extranet.messages"),
                accessor: "nrMessages",
                width: 125,
                filterable: false,
                Cell: row => (
                    <a className="subcatlink" onClick={(e) => this.props.onNavigateToMessages(row.row._original)}><span className="alignnumeric">{row.value}</span> <i className="fa fa-envelope-o" aria-hidden="true"></i></a>
                )
            }
        ]   

        return (
            <div className="container-fluid">
                <div className="row">
                    <FormTable 
                        data={this.props.projects}
                        columns={columns}
                        filterable={true}
                        defaultFiltered={[{id:"isClosed", value: false}]} 
                        defaultSorted={[{id:"datStart", desc: true}]} />
                </div>
            </div>
        );
    }
}

export default ControlProjects;


// WEBPACK FOOTER //
// ./src/Components/Extranet/Pages/ControlProjects.js